import '@/assets/mcss/mbase.css'
import '@/assets/mcss/mheader.less'
import '@/assets/mcss/mfooter.less'
import '@/assets/mcss/msolustion.less'
import '@/assets/mcss/mcoopercation.less'
import '@/assets/mcss/toast.less'
import '@/assets/js/Toast.js'
import axios from 'axios'

$(function() {
    $('document').ready(function() {
        function isPlaceholder() {
            var input = document.createElement('input');
            return 'placeholder' in input;
        }
        if (!isPlaceholder()) { //不支持placeholder 用jquery完成
            $(document).ready(function() {
                if (!isPlaceholder()) {
                    $("input").not("input[type='password']").each( //把input绑定事件 排除password框
                        function() {
                            if ($(this).val() == "" && $(this).attr("placeholder") != "") {
                                $(this).val($(this).attr("placeholder"));
                                $(this).focus(function() {
                                    if ($(this).val() == $(this).attr("placeholder")) $(this).val("");
                                });
                                $(this).blur(function() {
                                    if ($(this).val() == "") $(this).val($(this).attr("placeholder"));
                                });
                            }
                        });
                }
            });
        }
    })
})
var API_HOST = process.env.API_HOST || ''
var getCodeCtr = true
var submitCtr = true
    // var API_HOST = 'http://website-sit.wangqian.cn'
$('#phone').on('blur', function() {
    var phone = $('#phone').val()
    var myPhoneReg = /^[1][3-9][0-9]{9}$/;
    if (!(myPhoneReg.test(phone))) {
        var m = phone.length ? '手机号错误' : '请输入手机号'
        $.Toast(m)
    }
})
$('#getCode').on('click', function() {
    console.log(getCodeCtr, 'click')
    if ($('#getCode').text() != '获取验证码' || !getCodeCtr) return
    var phone = $('#phone').val()
    console.log('111111')
    var myPhoneReg = /^[1][3-9][0-9]{9}$/;
    if (!(myPhoneReg.test(phone))) {
        var m = phone.length ? '手机号错误' : '请输入手机号'
        $.Toast(m)
    } else {
        getCode(phone)
    }
})
$('#verifyCode').on('blur', function() {
    var code = $('#verifyCode').val()
    var codeReg = /^[0-9]{6}$/;
    if (!(codeReg.test(code))) {
        var m = code.length ? '验证码错误' : '请输入验证码'
        $.Toast(m)
    } else {
        verifyCode()
    }
})
$('#submit').on('click', function() {
    // if ($('#submit').hasClass('disable')) return
    var code = $('#verifyCode').val()
    var phone = $('#phone').val()
    var codeReg = /^[0-9]{6}$/;
    var myPhoneReg = /^[1][3-9][0-9]{9}$/;
    if (!(myPhoneReg.test(phone))) {
        var m = phone.length ? '手机号错误' : '请输入手机号'
        $.Toast(m)
    } else if (!(codeReg.test(code))) {
        var x = code.length ? '验证码错误' : '请输入验证码'
        $.Toast(x)
    } else {
        verifyCode().then(res => {
            if (res && !($('#submit').hasClass('disable')) && submitCtr) {
                submitCtr = false
                submitForm()
            }
        }, rej => { console.log('验证码错误') })
    }
})

function getCode(phone) {
    getCodeCtr = false
    console.log(getCodeCtr, '2')
    var params = {
        data: {
            phone: phone
        }
    }
    axios.post(`${API_HOST}/appapi/cooptition/geneVeriyCode`, params).then((res) => {
        console.log(getCodeCtr, '3')
        if (res.data.code === '00000') {
            countDown()
        } else if(res.data.code === '10005') {
          //同一IP重复点击3次，需获取图形验证码
          getCodeCtr = true
          getImgCode()
        } else {
            $.Toast(res.data.message)
            getCodeCtr = true
        }
    })
}

function verifyCode() {
    var phone = $('#phone').val()
    var veriyCode = $('#verifyCode').val()
    var params = {
        data: {
            phone,
            veriyCode
        }
    }
    return axios.post(`${API_HOST}/appapi/cooptition/validateVeriyCode`, params).then((res) => {
        if (res.data.code === '00000') {
            $('#submit').removeClass('disable')
            return true
        } else {
            $.Toast(res.data.message)
            $('#submit').addClass('disable')
        }
    })
}

function submitForm() {
    var phone = $('#phone').val()
    var veriyCode = $('#verifyCode').val()
    var fullName = $('#name').val()
    var company = $('#company').val()
    var cooptition = $('#content').val()
    var params = {
        data: {
            phone,
            veriyCode,
            fullName,
            company,
            cooptition
        }
    }
    axios.post(`${API_HOST}/appapi/cooptition/add`, params).then((res) => {
        if (res.data.code === '00000') {
            $.Toast('合作意向提交成功')
            setTimeout(() => { window.location.href = window.location.href }, 3000)
        } else {
            submitCtr = true
            $.Toast(res.data.message)
        }
    })
}

function countDown() {
    $('#getCode').text(60 + ' s')
    var t1 = parseInt(new Date().getTime() / 1000)
    var timer = setInterval(() => {
        let totalSecond = 60
        let t2 = parseInt(new Date().getTime() / 1000)
        let leftSecond = totalSecond - (t2 - t1) // 剩余秒数
        if (leftSecond >= 0) {
            $('#getCode').text(leftSecond + ' s')
        } else {
            $('#getCode').text('获取验证码')
            getCodeCtr = true
            clearInterval(timer)
        }
    }, 1000)
}


// 图形验证码
$('#popup').on('touchmove', function(e) {
    e.preventDefault()
}, false)

// 获取图形验证码并弹窗展示
function getImgCode() {
    let phone = $("#phone").val();
    let params = {
      data: {phone}
    };
    axios.post(`${API_HOST}/appapi/cooptition/getImageCode`, params,  {
        responseType: 'blob',
        emulateJSON: true
      }).then((res) => {
      $('#popup').css('display', 'block')
      renderImg(res)
    //   if (res.data.code === '00000') {
    //     renderImg(res)
    //     // initDrawer.drawPic('2345')
    //   } else {
    //     $.Toast(res.data.message);
    //   }
    })
  }
  // 将后端返回图形渲染
  function renderImg(res) {
    console.log(res)
    let img = document.getElementById('img');
    img.onload = function (e) {
      // 元素的onload 事件触发后将销毁URL对象, 释放内存。
      window.URL.revokeObjectURL(img.src)
    }
    // 浏览器允许使用URL.createObjectURL()方法，针对 Blob 对象生成一个临时 URL。
    // 这个 URL 以blob://开头,表明对应一个 Blob 对象。
    img.src = window.URL.createObjectURL(res.data)
  }
  // 刷新验证图形验证码
$('.update').click(function() {
    getImgCode()
  })
  
  
  $('.close').click(function() {
    closePop ()
  })
  
  
  $('.cancel').click(function() {
    closePop ()
  })

  function closePop () {
    $('.code').val("")
    $('#popup').css('display', 'none')
  }
  
  $('.confirm').click(function() {
    let validateCode = $('.code').val()
    if(validateCode.length === 0) {
      $.Toast('请输入图形验证码', 'top');
      return
    }
    let phone = $("#phone").val();
    let params = {
      data: {
        validateCode,
        phone
      }
    };
    axios.post(`${API_HOST}/appapi/cooptition/validateImageCode`, params).then((res) => {
      if (res.data.code === '00000') {
        // $.Toast(1, res.data.message);
        closePop ()
        countDown()
        // getCode($('#phone').val())
      } else {
        $.Toast(res.data.message, 'top');
      }
    })
  })